import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import Select from '../../../../../components/forms/Select'
import { hasBooleanValue, hasValue } from '../../../../../utils/NumberUtil'
import Checkbox from '../../../../../components/forms/Checkbox'
import NetworkAction from '../../../../../referencial/components/network/actions/NetworkAction'
import StationImportCodeMessage from '../../../../../import/components/utils/StationImportCodeMessage'
import Icon from '../../../../../components/icon/Icon'
import { StyledFieldSet, StyledLegend, StyledSpan } from '../../../../../components/StyledElements'
import IntegrationModeDialog from 'import/components/content/IntegrationModeDialog'
import { Grid } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

const measureOptions = () => [
    {
        value: 'DATA_NOTHING',
        label: i18n.noDataIntegration,
    },
    {
        value: 'DATA_REPLACE_HISTO',
        label: 'Remplacer tout l\'historique',
    },
    {
        value: 'DATA_ADD_NEW_DATA',
        label: 'Ajouter uniquement les nouvelles données',
    },
]

const handleChangeDataIntegration = (integration, jobDataTypes, setJobDataTypes) => {
    const dataTypes = jobDataTypes.filter(d => !d.includes('DATA'))
    if (integration) {
        dataTypes.push(integration)
    }
    setJobDataTypes(dataTypes)
}

// const handleChangeStationIntegration = (integration, jobDataTypes, setJobDataTypes) => {
//     const dataTypes = jobDataTypes.filter(d => !d.includes('station'))
//     if (integration) {
//         dataTypes.push('stationIntegration')
//     }
//     setJobDataTypes(dataTypes)
// }

const getDataTypes = (type, jobDataTypes) => {
    if (jobDataTypes && jobDataTypes.length) {
        return jobDataTypes.find(d => d.includes(type)) || ''
    }
    return ''
}


const AddQualitoStepOptionsAdes = ({
    station,
    changeStation,
    filters,
    changeFilters,
    jobDataTypes,
    setJobDataTypes,
}) => {
    const dispatch = useDispatch()

    const {
        networks,
    } = useSelector(store => ({
        networks: store.NetworkReducer.networks,
    }), shallowEqual)

    // const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (!networks.length) {
            dispatch(NetworkAction.fetchNetworks())
        }
    }, [])

    const descriptionImportModes = [
        { code: 'all', name: i18n.waterPointAndHisto },
        { code: 'PointEau', name: i18n.pointeauOnly },
    ]
    const oldCodeWithoutDesignation = hasValue(station.code) && station.code.length === 10 && !station.code.startsWith('BSS') && station.code[5] === 'X'
    return (
        <StyledFieldSet>
            <StyledLegend>
                <StyledSpan>{i18n.options}</StyledSpan>
            </StyledLegend>
            <Grid container spacing={2}>
                <Grid size={3}>
                    <Input
                        value={station.code}
                        onChange={v => changeStation({ code: v })}
                        title={i18n.code}
                        noSpace
                    />
                </Grid>
                <Grid size={9}>
                    { oldCodeWithoutDesignation ? (
                        <Grid container spacing={2} alignItems={'center'}>
                            <Grid size={1}>
                                <WarningAmberIcon sx={{ color: 'orange' }}/>
                            </Grid>
                            <Grid size={11}>
                                <h6>{ i18n.oldCodeWithoutDesignationMessage }</h6>
                            </Grid>
                        </Grid>
                    ) : (hasValue(station.code) && <StationImportCodeMessage code={station.code} stationType='quality'/>) }
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems={'center'}>
                <Grid size={4}>
                    <Select
                        label={ i18n.importMode }
                        options={ descriptionImportModes }
                        value={ filters.descriptionImportMode }
                        onChange={ v => changeFilters({ descriptionImportMode: v }) }
                    />
                </Grid>
                <Grid size={4}>
                    <Checkbox
                        checked={ hasBooleanValue(filters.syncEvents) ? filters.syncEvents : true }
                        label={ i18n.syncEvents }
                        onChange={ v => changeFilters({ syncEvents: v }) }
                    />
                </Grid>
                <Grid size={4}>
                    <Checkbox
                        checked={ hasBooleanValue(filters.syncNetworks) ? filters.syncNetworks : true }
                        label={ i18n.syncNetworks }
                        onChange={ v => changeFilters({ syncNetworks: v }) }
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={ measureOptions() }
                        obligatory={true}
                        label={ i18n.dataIntegration }
                        value={ getDataTypes('DATA', jobDataTypes) }
                        labelSpan={ <IntegrationModeDialog /> }
                        onChange={ v => handleChangeDataIntegration(v, jobDataTypes, setJobDataTypes) }
                    />
                </Grid>
                <Grid size={4}>
                    <Checkbox
                        checked={ filters.dontCheckInternalReferences }
                        label={ i18n.dontCheckInternalReferences }
                        onChange={ v => changeFilters({ dontCheckInternalReferences: v }) }
                    />
                </Grid>
                <Grid size={4}>
                    <Checkbox
                        checked={ filters.doNotImportClosedStations }
                        label={ i18n.doNotImportClosedStations }
                        onChange={ v => changeFilters({ doNotImportClosedStations: v }) }
                    />
                </Grid>
                <Grid size={3}>
                    <Checkbox
                        checked={ filters.addCodesToADESNetwork }
                        label={ i18n.addCodesToADESNetwork }
                        onChange={ v => changeFilters({ addCodesToADESNetwork: v }) }
                    />
                </Grid>
                <Grid size={5}>
                    <Select
                        options={ networks }
                        keyLabel='mnemonic'
                        label={ i18n.network }
                        nullLabel='&nbsp;'
                        onChange={ value => changeFilters({ selectedNetwork: value }) }
                        value={ filters.selectedNetwork }
                        keyValue='id'
                    />
                </Grid>
            </Grid>
        </StyledFieldSet>
    )
}

AddQualitoStepOptionsAdes.propTypes = {
}

export default AddQualitoStepOptionsAdes